var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "recommended-card-modal" },
      on: {
        click: function ($event) {
          _vm.show = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "recommended-card-box",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "recommended-card-close-block" }, [
            _c(
              "a",
              {
                staticClass: "recommended-card-close-button",
                on: {
                  click: function ($event) {
                    _vm.show = false
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "recommended-card-label" }, [
              _vm._v(_vm._s(_vm.$t("detail.recommendedCardModalTitle"))),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "recommended-card-description",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("detail.recommendedCardModalDescription")
                ),
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "recommended-card-images" }, [
      _c("div", [
        _c("img", { attrs: { src: "/img/cards/pre-cez-eon-drivalia.png" } }),
      ]),
      _vm._v(" "),
      _c("div", [_c("img", { attrs: { src: "/img/cards/cez-drivalia.png" } })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }